export default {
  SET_CURRENT_TRAINER_SURVEY_ENTRIES(state, newValue) {
    state.trainer_survey_entries = newValue
  }
}
